import '../Sidebar/Sidebardigital';
import Sidebar from '../Sidebar/Sidebardigital';
import React from 'react';

export default function Contactus()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
            <br/><br/><br/>
        <h1> CONTACT US</h1><br></br>
        <p> Gatisheel is an IOT company which caters to the Agriculture sector. We are building a data powerhouse which is required for the critical decision making.  
            <br></br><br></br>
            <b>Company Address</b><br></br><br></br>
            Gatisheel Agritech Private limited<br></br>
            Unit Number 1106<br></br>
            EMAAR The Palm Square<br></br>
            Sector 66<br></br>
            Gurgaon 122002<br></br> 

            Mob +91 7042214002<br></br> 
        </p>
        <a href = "https://wa.me/+919518802185">Connect on Whatsapp ➞</a><br></br><br></br>
        <p> Journery of thousand miles starts with the single step. We are taking those baby steps which will make agriculture sustainable for the future generations.</p>

        </div>
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        </div>
     </>
    )   
   };